<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-confirm @confirm="toAddPage" style="width: 80px;" value="添加" />
        <!--<button-add :pathName="addBusinessRouterName" />-->
        <button-delete @deleteSelection="deleteSelection" />
      </div>
      <input-search placeholder="标题" @search="searchKey" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" @changeSwitch="changeSwitch" :deleteTipInfo="'是否确认删除？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" @publishRow="publishRow" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />


    <el-dialog title="请选择下发园区" :visible.sync="publishParkDialogVisible" width="40%">
      <div style="text-align: left;">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedParks" @change="handleCheckedCitiesChange" style="display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;">
          <el-checkbox style="margin-bottom: 10px;" v-for="parkName in parkNameList" :label="parkName" :key="parkName">{{parkName}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPublish" size="small">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmPublish">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../../../components/Button/ButtonDelete'
import ButtonExport from '../../../../../components/common/buttons/button-export'
import ButtonUpload from '../../../../../components/common/buttons/button-upload'
import InputSearch from '../../../../../components/Input/InputSearch'
import InputSelect from '../../../../../components/Input/InputSelect'
import TableMain from '../../../../../components/Table/TableMain'
import {api} from '../../../../api/Summary'
import {errorHandler} from '../../../../../utils/errorHandler'
import {nAlert, nSuccess} from '../../../../../utils/notice'
import {bus} from '../../../../../utils/bus'
import ButtonConfirm from '../../../../../components/Button/ButtonConfirm'

export default {
  components: {
    ButtonConfirm,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'upper-information-yq-notice-management',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '信息发布',
        name: 'group-profile-info'
      }, {
        value: ''
      }],
      addBusinessRouterName: 'upper-information-add-yq-notice',
      selectTitle: '租赁状态',
      operationArr: ['modify', 'publish', 'delete'],
      tableHead: [{
        prop: 'title',
        label: '标题'
      }, {
        prop: 'responsiblePersonName',
        label: '添加人'
      }, {
        prop: 'isTopInPageState',
        label: '是否置顶',
        isSwitch: true
      }, {
        prop: 'readingCount',
        label: '阅读数'
      }, {
        prop: 'publishYqFullNames',
        label: '已发布园区'
      }],
      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        searchKey: '',
        pageSize: 10,
        pageNum: 1,
        type: ''
      },
      type: '',

      checkAll: false,
      publishParkDialogVisible: false,
      parkList: [],
      parkNameList: [],
      checkedParks: [],
      isIndeterminate: false
    }
  },
  created () {
    this.type = this.$route.params.type
    this.requestData.type = this.$route.params.type
    if (this.type === '0') {
      this.breadcrumb[1].value = '要文快讯'
    } else if (this.type === '1') {
      this.breadcrumb[1].value = '通知公告'
    } else if (this.type === '2') {
      this.breadcrumb[1].value = '最新政策'
    } else if (this.type === '3') {
      this.breadcrumb[1].value = '智慧党建'
    } else if (this.type === '4') {
      this.breadcrumb[1].value = '其他资讯'
    }
    this.parkList = bus.global.upperData.yqAppCodeList || []
    let parkNameList = []
    this.parkList.map(park => {
      parkNameList.push(park.fullName)
    })
    this.parkNameList = parkNameList
    this.getPage()
  },
  methods: {
    getPage () {
      this.$axios.post(api.getYqNoticePage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map(v => {
              if (v.createTime) {
                v.createTime = v.createTime.slice(0, 19)
              }
              if (v.isTop === '1') {
                v.isTopInPageState = true
              } else {
                v.isTopInPageState = false
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取公告失败'))
    },
    search (v) {
      this.requestData.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.requestData.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.requestData.pageNum = data[0]
      this.requestData.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    goToModifyPage (code) {
      this.$router.push({
        path: `/upper_strata/information/modify_yq_notice/${this.type}/${code}`
      })
    },
    toAddPage () {
      this.$router.push({
        path: `/upper_strata/information/add_yq_notice/${this.type}`
      })
    },
    deleteSelection () {
      if (this.selectionArr.length === 0) {
        nAlert('请先选择需要删除的通知公告')
        return false
      } else {
        this.$confirm('是否确认删除通知公告？', '提示')
          .then(() => {
            this.deleteLine(this.selectionArr)
          })
          .catch(() => {
            console.log('取消删除')
          })
      }
    },
    deleteLine (code) {
      this.$axios.post(api.deleteyqNoticeByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.selectionArr = []
            this.getPage()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    // 修改置顶状态
    changeSwitch (data) {
      this.$confirm('是否确认修改该置顶状态？', '提示')
        .then(() => {
          if (data.isTopInPageState) {
            data.isTop = '1'
          } else {
            data.isTop = '0'
          }
          for (let i in data) {
            if (data[i] === '--') {
              data[i] = ''
            }
          }
          this.$axios.post(api.updateyqNotice, data)
            .then(res => {
              nSuccess('修改成功')
              this.getPage()
            })
            .catch(errorHandler('修改失败'))
        })
        .catch(() => {
          this.getPage()
        })
    },
    // 发布
    publishRow (row) {
      this.publishData = row
      this.publishParkDialogVisible = true
    },

    handleCheckAllChange(val) {
      this.checkedParks = val ? this.parkNameList : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.parkList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.parkList.length;
    },

    // 取消发布
    cancelPublish () {
      this.publishParkDialogVisible = false
      this.checkAll = false
      this.checkedParks = []
      this.isIndeterminate = false
    },

    // 确认发布
    confirmPublish () {
      let publishYqFullNamesArr = []
      let publishYqShortNamesArr = []
      this.parkList.map(v => {
        if (this.checkedParks.indexOf(v.fullName) !== -1) {
          publishYqFullNamesArr.push(v.fullName)
          publishYqShortNamesArr.push(v.shortName)
        }
      })
      let publishYqFullNames = publishYqFullNamesArr.join(',')
      let publishYqShortNames = publishYqShortNamesArr.join(',')
      this.$axios.post(api.publishGroupNew, {
        code: this.publishData.code,
        publishYqFullNames,
        publishYqShortNames,
      })
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('发布成功')
            this.publishParkDialogVisible = false
            this.getPage()
          }
        })
        .catch(errorHandler('发布失败'))
    },
  },
  watch: {}
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/Summary/InformationDelivery/InformationNotice/YqNoticeManagement.vue